export function times<T>(n: number, iteratee: (num: number) => T): T[] {
  return Array.from({ length: n }, (_, num) => iteratee(num));
}
